import {
	cond,
	conforms,
	constant,
	identity,
	isObject,
	isString,
	mapValues,
	matches,
	replace,
	startsWith,
	stubTrue,
	update,
} from 'lodash/fp';

import {
	SanitizeReduxActions,
	SanitizeReduxState,
	SanitizeSentryEvent,
} from '@skippay/core/global/errorTracking';
import { evolve } from '@skippay/core/utils/fp';

export const SANITIZED = `*SANITIZED*`;

export const sanitizeReduxState: SanitizeReduxState = mapValues((value, key) => {
	if (isString(value) && key === `password`) {
		return SANITIZED;
	}
	return isObject(value) ? sanitizeReduxState(value) : value;
});

export const sanitizeReduxActions: SanitizeReduxActions = cond([
	[
		conforms({
			meta: matches({ field: `password` }),
			type: startsWith(`@@redux-form`),
		}),
		update([`payload`], constant(SANITIZED)),
	],
	[stubTrue, identity],
]);

const sanitizeSimpleId = replace(/(\/overeni-mobilem.*[?&]token=)(\w+)/, `$1${SANITIZED}`);
export const sanitizeSentryEvent: SanitizeSentryEvent = update(
	[`request`],
	evolve({
		url: sanitizeSimpleId,
		headers: {
			Referer: sanitizeSimpleId,
		},
	})
);
